
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/finance/page/[id]",
      function () {
        return require("private-next-pages/cases/finance/page/[id].tsx");
      }
    ]);
  